export default __webpack_public_path__ + "static/media/TassoLogo.3a0f5723.svg";